export default "__VITE_PUBLIC_ASSET__197877d7__"